module["exports"] = [
  "#####",
  "####",
  "###",
  "##",
  "#"
];
